import { useSelector } from "react-redux";
import "./style.css";
import React from "react";
import {
  faArrowLeft,
  faArrowRight,
  faCheck,
  faFloppyDisk,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export default function ButtonAHSF(props) {
  const JsonDataa = useSelector((state) => state.FetchDataJson);

  return (
    <>
      {props.show && (
        <div>
          <button
            style={props.style}
            className="custom-button"
            type={props.type}
            onClick={props.onClick}
            disabled={props.disabled}
            title={
              props.lang == "ar"
                ? JsonDataa?.JsonData[props.fieldsName]?.nameEN
                : JsonDataa?.JsonData[props.fieldsName]?.nameAR
            }
            id={props.id}
          >
            <p>
              {props.lang !== "en"
                ? JsonDataa?.JsonData[props.fieldsName]?.nameAR
                : JsonDataa?.JsonData[props.fieldsName]?.nameEN}
            </p>

            <div id="ButtonsIcons">
              {props.fieldsName == "SaveButton" && (
                <FontAwesomeIcon icon={faFloppyDisk} />
              )}
              {props.fieldsName == "NextButton" && (
                <FontAwesomeIcon
                  icon={props.lang == "ar" ? faArrowLeft : faArrowRight}
                />
              )}
              {props.fieldsName == "PreviousButton" && (
                <FontAwesomeIcon
                  icon={props.lang == "ar" ? faArrowRight : faArrowLeft}
                />
              )}
              {props.fieldsName == "ApplyButton" && (
                <FontAwesomeIcon icon={faCheck} />
              )}
            </div>
          </button>
        </div>
      )}
    </>
  );
}
